/* Swee Choon Heritage Wrap — free gift with Mini Catering (Oct 2026).
 * - Shows the free-gift box on Mini Catering product pages (pre-ticked).
 * - Keeps the cart in line: adds 1 wrap when a qualifying Mini Catering item is in the cart and the
 *   customer hasn't opted out; removes the wrap if no Mini Catering item remains; caps it at 1.
 * - Price is made $0 by the automatic Shopify discount, not by this script.
 * Mode: window.SC_HW.mode 'test' => only browsers that opened a page with ?hw_test=1 (undo: ?hw_test=0).
 */
(function () {
  'use strict';
  var C = window.SC_HW;
  if (!C || !C.variantId) return;
  try {
    var qs = new URLSearchParams(location.search);
    if (qs.get('hw_test') === '1') localStorage.setItem('scHWTest', '1');
    if (qs.get('hw_test') === '0') localStorage.removeItem('scHWTest');
  } catch (e) {}
  var active = C.mode === 'live';
  try { if (localStorage.getItem('scHWTest') === '1') active = true; } catch (e) {}
  if (!active) return;

  var VID = Number(C.variantId);
  var QUAL = (C.qualifying || []).map(Number);
  var soldOut = !C.available;
  var nativeFetch = window.fetch.bind(window);
  var busy = false, again = false, timer = null;

  function optedOut() { try { return localStorage.getItem('scHWOptOut') === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? localStorage.setItem('scHWOptOut', '1') : localStorage.removeItem('scHWOptOut'); } catch (e) {} }
  function isCartPage() { return /^\/cart\/?$/.test(location.pathname); }
  function getCart() { return nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return nativeFetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-SC-HW': '1' }, body: JSON.stringify(body) });
  }
  var staleDrawer = false;
  function drawerOpen() { return !!document.querySelector('#CartDrawer.drawer--is-open') || document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open'); }
  function rebuildDrawer() { try { var $ = (window.theme && theme.jQuery) || window.jQuery; if ($) $(document.body).trigger('added.ajaxProduct'); } catch (e) {} }
  /* kind 'add' follows the customer's own add-to-cart (drawer opens anyway); 'remove' must not pop the drawer open. */
  function refreshUI(kind) {
    if (isCartPage()) { location.reload(); return; }
    if (kind === 'add' || drawerOpen()) { staleDrawer = false; rebuildDrawer(); } else { staleDrawer = true; }
  }
  document.addEventListener('click', function (e) {
    if (!staleDrawer) return;
    var a = e.target.closest && e.target.closest('a[href="/cart"], .js-drawer-open-cart, .cart-link');
    if (a) { staleDrawer = false; setTimeout(rebuildDrawer, 50); }
  }, true);

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (cart) {
      var items = cart.items || [];
      var hasMini = items.some(function (i) { return QUAL.indexOf(Number(i.product_id)) !== -1; });
      var wraps = items.filter(function (i) { return Number(i.variant_id) === VID; });
      var wrapQty = wraps.reduce(function (s, i) { return s + i.quantity; }, 0);
      var updates = null;
      if (wraps.length && (!hasMini || optedOut() || soldOut)) {
        updates = {}; wraps.forEach(function (i) { updates[i.key] = 0; });
      } else if (wrapQty > 1) {
        updates = {}; wraps.forEach(function (i, n) { updates[i.key] = n === 0 ? 1 : 0; });
      }
      if (updates) {
        window.__CATERING_CART_CLEAR_APPROVED = true;
        return post('/cart/update.js', { updates: updates }).then(function () { refreshUI('remove'); }).finally(function () { window.__CATERING_CART_CLEAR_APPROVED = false; });
      }
      if (hasMini && !wraps.length && !optedOut() && !soldOut) {
        return post('/cart/add.js', { items: [{ id: VID, quantity: 1, properties: { _free_gift: 'Mini Catering' } }] }).then(function (r) {
          if (r.status === 422) { soldOut = true; markGone(); return; }
          if (r.ok) refreshUI('add');
        });
      }
    }).catch(function () {}).finally(function () {
      busy = false;
      if (again) { again = false; schedule(400); }
    });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(reconcile, ms == null ? 350 : ms); }

  /* Watch other scripts' cart requests (Aris options, theme, cart drawer). */
  var CART_RE = /\/cart\/(add|change|update|clear)/;
  window.fetch = function (input, init) {
    var url = (input && input.url) || String(input || '');
    var mine = init && init.headers && (init.headers['X-SC-HW'] || (init.headers.get && init.headers.get('X-SC-HW')));
    var p = nativeFetch.apply(this, arguments);
    if (!mine && CART_RE.test(url)) p.then(function (r) { if (r.ok) schedule(); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__schwUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (CART_RE.test(String(x.__schwUrl || ''))) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) schedule(); });
    return xs.apply(this, arguments);
  };

  /* Product-page box */
  function markGone() {
    var box = document.getElementById('SCHW'); if (!box) return;
    box.classList.add('is-gone');
    var o = box.querySelector('[data-schw-opt]'), g = box.querySelector('[data-schw-gone]'), s = box.querySelector('[data-schw-stock]');
    if (o) o.hidden = true; if (s) s.hidden = true; if (g) g.hidden = false;
    var t = document.querySelector('.schw-teaser'); if (t && t.parentNode) t.parentNode.remove();
  }
  function initBox() {
    var box = document.getElementById('SCHW');
    if (!box) return;
    box.hidden = false;
    /* Teaser pill under the price that jumps to the box */
    var priceEl = document.querySelector('.product-single__meta .product__price');
    if (priceEl && !document.querySelector('.schw-teaser') && box.getAttribute('data-available') !== 'false') {
      var t = document.createElement('a');
      t.href = '#SCHW'; t.className = 'schw-teaser';
      t.innerHTML = '🎁 FREE Heritage Wrap with this order';
      t.addEventListener('click', function (e) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      var wrapDiv = document.createElement('div'); wrapDiv.appendChild(t);
      priceEl.parentNode.insertBefore(wrapDiv, priceEl.nextSibling);
    }
    if (soldOut || box.getAttribute('data-available') === 'false') { soldOut = true; markGone(); }
    var chk = box.querySelector('[data-schw-check]');
    if (chk) {
      chk.checked = !optedOut();
      chk.addEventListener('change', function () { setOptOut(!chk.checked); schedule(50); });
    }
    var main = box.querySelector('[data-schw-main]');
    var thumbs = [].slice.call(box.querySelectorAll('.schw__thumb'));
    var idx = 0;
    function show(n) {
      idx = (n + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      main.src = thumbs[idx].getAttribute('data-mid'); main.alt = thumbs[idx].getAttribute('data-alt');
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var lb = document.getElementById('SCHWLightbox'), lbImg = lb && lb.querySelector('[data-schw-lb-img]');
    if (lb && lb.parentNode !== document.body) document.body.appendChild(lb);
    function lbShow(n) { show(n); lbImg.src = thumbs[idx].getAttribute('data-full'); lbImg.alt = thumbs[idx].getAttribute('data-alt'); }
    box.querySelector('.schw__main').addEventListener('click', function () { if (!lb) return; lbShow(idx); lb.hidden = false; });
    if (lb) {
      lb.querySelector('.schw-lb__close').addEventListener('click', function () { lb.hidden = true; });
      lb.querySelector('.schw-lb__prev').addEventListener('click', function () { lbShow(idx - 1); });
      lb.querySelector('.schw-lb__next').addEventListener('click', function () { lbShow(idx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.hidden = true; });
      document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') lb.hidden = true; if (e.key === 'ArrowLeft') lbShow(idx - 1); if (e.key === 'ArrowRight') lbShow(idx + 1); });
    }
  }

  /* Cart drawer + cart page: show the wrap as a FREE GIFT with no quantity controls. */
  function decorate() {
    var inputs = document.querySelectorAll('input[data-id^="' + VID + ':"], input[id^="updates_' + VID + '"], input[data-id="' + VID + '"], input[id="updates_' + VID + '"]');
    [].forEach.call(inputs, function (inp) {
      var row = inp.closest('.ajaxcart__product, .cart__row, .cart-item, tr') || inp.parentElement;
      if (!row || row.getAttribute('data-schw-done')) return;
      row.setAttribute('data-schw-done', '1');
      var q = inp.closest('.js-qty__wrapper') || inp;
      q.style.display = 'none';
      var tag = document.createElement('span'); tag.className = 'schw-cart-tag'; tag.textContent = '🎁 Free gift';
      q.parentNode.insertBefore(tag, q);
      /* Removing the wrap from the cart page = opting out, so it isn't re-added on reload. */
      [].forEach.call(row.querySelectorAll('a[href*="quantity=0"], .cart__remove, [data-cart-remove]'), function (a) {
        a.addEventListener('click', function () { setOptOut(true); }, true);
      });
      var walker = document.createTreeWalker(row, NodeFilter.SHOW_TEXT, null), hits = [], n;
      while ((n = walker.nextNode())) { if (/^\s*(S?\$|SGD\s?)0\.00\s*$/.test(n.nodeValue)) hits.push(n); }
      hits.forEach(function (t) { var b = document.createElement('strong'); b.className = 'schw-cart-free'; b.textContent = 'FREE'; t.parentNode.replaceChild(b, t); });
    });
  }
  var decoT = null;
  function watchCart() {
    var st = document.createElement('style');
    st.textContent = '.schw-cart-tag{display:inline-block;white-space:nowrap;font-family:Jost,sans-serif;font-size:12px;font-weight:600;color:#ae0a2b;background:#fdecef;border-radius:999px;padding:3px 10px}.schw-cart-free{color:#ae0a2b;font-weight:700;letter-spacing:.08em}';
    document.head.appendChild(st);
    decorate();
    new MutationObserver(function () { clearTimeout(decoT); decoT = setTimeout(decorate, 60); }).observe(document.body, { childList: true, subtree: true });
  }

  function unmarkGone() {
    var box = document.getElementById('SCHW'); if (!box) return;
    box.classList.remove('is-gone'); box.setAttribute('data-available', 'true');
    var o = box.querySelector('[data-schw-opt]'), g = box.querySelector('[data-schw-gone]');
    if (o) o.hidden = false; if (g) g.hidden = true;
  }
  /* Live stock check — page HTML can be cached, so ask Shopify directly before touching the cart. */
  function liveStock() {
    return nativeFetch('/products/swee-choon-heritage-wrap.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (p) {
      if (!p || typeof p.available !== 'boolean') return;
      if (!p.available) { soldOut = true; markGone(); }
      else if (soldOut) { soldOut = false; unmarkGone(); }
    }).catch(function () {});
  }
  function initPromo() {
    [].forEach.call(document.querySelectorAll('[data-schw-promo]'), function (el) {
      if (soldOut) { el.hidden = true; return; }
      el.hidden = false;
      var a = el.querySelector('[data-schp-scroll]');
      if (a) a.addEventListener('click', function (e) {
        var t = document.querySelector('[id*="catering_options"], .catering-options, [id*="catering-options"]');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }
  /* Site-wide announcement bar (hidden on checkout-type pages and once sold out). */
  function initBar() {
    if (soldOut || document.getElementById('SCHWBar')) return;
    try { if (sessionStorage.getItem('scHWBarClosed') === '1') return; } catch (e) {}
    var bar = document.createElement('div');
    bar.id = 'SCHWBar';
    bar.innerHTML = '<a href="/pages/mini-catering">🎁 <b>FREE Swee Choon Heritage Wrap</b> with every Mini Catering order — limited edition <span>Order now →</span></a><button type="button" aria-label="Close">×</button>';
    var st = document.createElement('style');
    st.textContent = '#SCHWBar{position:relative;z-index:30;background:#ae0a2b;color:#fff;font-family:Jost,sans-serif;font-size:14px;text-align:center;padding:9px 40px;line-height:1.35}#SCHWBar a{color:#fff!important;text-decoration:none}#SCHWBar b{font-weight:600}#SCHWBar span{display:inline-block;margin-left:8px;border-bottom:1px solid #fff;font-weight:600}#SCHWBar button{position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:0;color:#fff;font-size:22px;cursor:pointer;line-height:1}@media(max-width:600px){#SCHWBar{font-size:13px;padding:8px 34px}#SCHWBar span{display:block;margin:2px 0 0;border:0;text-decoration:underline}}';
    document.head.appendChild(st);
    document.body.insertBefore(bar, document.body.firstChild);
    bar.querySelector('button').addEventListener('click', function () { bar.remove(); try { sessionStorage.setItem('scHWBarClosed', '1'); } catch (e) {} });
  }
  function start() { initBox(); initPromo(); initBar(); watchCart(); liveStock().then(function () { if (soldOut) { initPromo(); var b = document.getElementById('SCHWBar'); if (b) b.remove(); } schedule(300); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
